import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5 2V12L4.5 17L2 15.5V5.5L13 0.5L15.5 2ZM4.5 7V16L14.5 11.3506V2.4541L4.5 7Z",
		fill: "black"
	})
});
export default SvgWall;
